/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, June 18th 2022, 7:15:35 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Paper, { PaperProps } from "@mui/material/Paper";

export const OSPaperContainer = (props: PaperProps) => {
  return (
    <Paper {...props} sx={{ ...props.sx, paddingLeft: 5, paddingRight: 5, paddingTop: 5, paddingBottom: 5 }}></Paper>
  );
};
